import React from 'react';
import classNames, { Argument } from 'classnames';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface KeyboardInputProps {
  onClear: () => void;
  isPassword?: boolean;
  className?: Argument;
  value: string | number;
  selection: [number, number];
}

const INPUT_MASK = '•';

const KeyboardInput: React.FC<KeyboardInputProps> = ({ value, selection = [0, 0], className, onClear, isPassword }) => {
  const scrollRef = React.useRef<HTMLDivElement>(null);

  const [start, end] = selection;
  const text = isPassword ? INPUT_MASK.repeat(value.toString()?.length):  value.toString();
  const before = text.slice(0, start);
  const highlight = text.slice(start, end);
  const after = text.slice(end);

  const hasValue = Boolean(value);

  React.useEffect(() => {
    const container = scrollRef.current;
    if (container) {
      container.scrollLeft = container.scrollWidth;
    }
  }, [text]);

  return (
    <div className="bg-input-bg p-4 flex flex-col gap-4 w-full rounded-card">
      <div className={classNames(
        'relative flex items-center text-center input focus:outline-none peer bg-input-bg pt-8 bg-white !py-5 min-h-[68px] overflow-x-auto scrollbar-hide',
        className
      )}
      >
        <div ref={scrollRef} className="flex-grow overflow-hidden">
          <span className={classNames('text-black inline-block pr-10 will-change-transform', className)}>
            {before}
            {highlight && <u>{highlight}</u>}
            {after}
          </span>
        </div>

        {Boolean(onClear) && hasValue && (
          <div
            onClick={onClear}
            data-testid="input-clear-btn"
            className="absolute top-4 right-8 size-7 w-16 h-full -mt-4 -mr-4 cursor-pointer flex justify-center items-center clearIcon"
          >
            <XMarkIcon className="m-auto size-3.5 w-8 h-8" />
          </div>
        )}
      </div>
    </div>
  );
};

export default KeyboardInput;
